/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsGetSchedule } from "../../funcs/llmEvalsGetSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetEvalScheduleRequest$inboundSchema,
};

export const tool$llmEvalsGetSchedule: ToolDefinition<typeof args> = {
  name: "llm-evals-get-schedule",
  description: `Get an eval schedule

Retrieves an eval schedule by ID, including the next scheduled fire time from Temporal when resolvable.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsGetSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
